import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Box, Skeleton, Typography } from '@mui/material';
import * as fileApi from '../../lib/api/file';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});


const ProfileInfo = ({ employee }) => {
    const [profileImg, setProfileImg] = useState('');
    useEffect(() => {    
      const loadProfileImage = async () => {
        try {        
          setProfileImg(await fileApi.profileImage(employee.profileImg));
        } catch (error) {
          console.error("이미지 호출 에러:", error);
        }
      };
  
      loadProfileImage();
  
      // 컴포넌트 언마운트 시 메모리 해제
      return () => {
        if (profileImg) URL.revokeObjectURL(profileImg);
      };
    }, [employee?.profileImg]);
  return (
    <>
      <Grid container >
        {employee && (
          <Grid xs={3} item textAlign="center">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 1,
              }}
            >
              {employee && employee.profileImg ? (
                <Img
                  style={{
                    width: 200,
                    height: 170,
                  }}
                  alt={employee.usrNm}
                  src={profileImg}
                />
              ) : (
                <Skeleton
                  variant="rectangular"
                  width={200}
                  height={170}
                  animation={false}
                />
              )}
            </Box>
          </Grid>
        )}
        <Grid
          item
          xs={employee ? 9 : 12}
          sx={{ flexGrow: 1 }}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"

            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">사번</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee.usrNo}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">이름</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee?.usrNm}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">부서</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee.dptNm}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">직급</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div"> {employee.gradeNm}</Typography>
            </Grid>
            
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"

            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">연락처</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee.telNo}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">이메일</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee.emlAddr}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">입사일</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{employee.entryDt}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">성별</Typography>
            </Grid>
            <Grid item xs={2}>
            <Typography variant="body2" component="div">
                {employee.gender ==="M" ?'남성':'여성'}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"

            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">우편번호</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div"> {employee.postAddrNm}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">주소</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body2" component="div"> {employee.postAddrTxt}</Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"

            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">참고사항</Typography>
            </Grid>
            <Grid item xs={11}>
              <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{employee.infoDesc}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ProfileInfo;
